const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  socket_data: state => state.user.socket_data,
  stateDeviceDetailData: state => state.device.setDeviceDetailData,
  paintStatus: state => state.app.paintStatus,
}
export default getters
